/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiSku
 */
export interface ApiSku {
  /**
   *
   * @type {string}
   * @memberof ApiSku
   */
  dataSource?: ApiSkuDataSourceEnum;
  /**
   *
   * @type {boolean}
   * @memberof ApiSku
   */
  monetized?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiSku
   */
  sku?: string;
}

/**
 * @export
 */
export const ApiSkuDataSourceEnum = {
  Manual: 'MANUAL',
  SegmentedPromoService: 'SEGMENTED_PROMO_SERVICE',
  VirtualBundleService: 'VIRTUAL_BUNDLE_SERVICE',
  Ruleset: 'RULESET',
} as const;
export type ApiSkuDataSourceEnum = typeof ApiSkuDataSourceEnum[keyof typeof ApiSkuDataSourceEnum];

export function ApiSkuFromJSON(json: any): ApiSku {
  return ApiSkuFromJSONTyped(json, false);
}

export function ApiSkuFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSku {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    dataSource: !exists(json, 'dataSource') ? undefined : json['dataSource'],
    monetized: !exists(json, 'monetized') ? undefined : json['monetized'],
    sku: !exists(json, 'sku') ? undefined : json['sku'],
  };
}

export function ApiSkuToJSON(value?: ApiSku | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    dataSource: value.dataSource,
    monetized: value.monetized,
    sku: value.sku,
  };
}
